import React, { useState } from "react";
import HeaderPage from "../components/HeaderPage";
import { toast } from "react-hot-toast";

const OffersPage = () => {
    const coupons = [
        {
            id: 1,
            code: "TRYNEW",
            leftLabel: "20% OFF",
            leftColor: "#6c757d",
            title: "TRYNEW",
            subText: "Add ₹99 more to avail this offer",
            description:
                "Use code TRYNEW & get 20% off on orders above ₹499. Maximum discount ₹200",
            saveText: "",
            action: "APPLY",
        },
        {
            id: 2,
            code: "FREESHIP",
            leftLabel: "₹100 OFF",
            leftColor: "#dc3545",
            title: "FREESHIP",
            subText: "",
            description: "Flat ₹100 off on all orders.",
            saveText: "Save ₹100 on this order",
            action: "APPLY",
        },
        {
            id: 3,
            code: "SALE50",
            leftLabel: "50% OFF",
            leftColor: "#343a40",
            title: "SALE50",
            subText: "Add ₹600 more to avail this offer",
            description:
                "Big Sale - Flat 50% off on everything on orders above ₹1000. Maximum discount ₹550",
            saveText: "",
            action: "APPLY",
        },
        {
            id: 4,
            code: "NEW50",
            leftLabel: "50% OFF",
            leftColor: "#dc3545",
            title: "NEW50",
            subText: "",
            description:
                "New customer offer – Flat 50% off on everything on orders above ₹399. Maximum discount ₹250",
            saveText: "Save ₹200 on this order",
            action: "APPLY",
        },
    ];

    const copyToClipboard = (code) => {
        navigator.clipboard.writeText(code);
        toast.success(`${code} copied!`);
    };

    const cardStyle = {
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        marginBottom: "15px",
    };


    return (
        <>
            <HeaderPage title={"Exclusive Offers"} />
            <main className="page-content bg-light pb-5" style={{ minHeight: "100vh" }}>
                <div className="container mt-0 ">
                    <h4 className="fw-bold text-center mb-4" style={{ color: "#7a5a33" }}>
                        💎 Grab Exciting Jewellery Offers 💎
                    </h4>
                    <div className="px-3">
                        <div className="row g-4">
                            {coupons.map((coupon) => (
                                <div key={coupon.id} style={cardStyle} className="d-flex">
                                    {/* Left Ribbon */}
                                    <div
                                        style={{
                                            backgroundColor: coupon.leftColor,
                                            color: "#fff",
                                            width: "60px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            writingMode: "vertical-rl",
                                            textOrientation: "mixed",
                                            fontWeight: "bold",
                                            fontSize: "13px",
                                            letterSpacing: "1px",
                                        }}
                                    >
                                        {coupon.leftLabel}
                                    </div>

                                    {/* Right Content */}
                                    <div className="flex-grow-1 p-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="fw-bold mb-0">{coupon.title}</h6>
                                            <button
                                                onClick={() => copyToClipboard(coupon.code)}
                                                className="btn btn-link fw-bold text-danger p-0"
                                                style={{ textDecoration: "none" }}
                                            >
                                                {coupon.action}
                                            </button>
                                        </div>

                                        {coupon.subText && (
                                            <p className="text-muted small mb-1">{coupon.subText}</p>
                                        )}

                                        {coupon.saveText && (
                                            <p className="text-success small fw-bold mb-1">
                                                {coupon.saveText}
                                            </p>
                                        )}

                                        <p className="small mb-0">{coupon.description}</p>
                                        <button
                                            className="btn btn-link text-decoration-none p-0 mt-1 small text-primary"
                                            style={{ fontWeight: "500" }}
                                        >
                                            + MORE
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>


                    <p className="text-center text-muted mt-4">
                        * Terms & Conditions Apply
                    </p>
                </div>
            </main>
        </>
    );
};

export default OffersPage;
